import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import { feedbackOptions } from '../../../../../configs/dropdownOptions';
import Select from 'react-select';
import CyberSecurity from '../../../../../apis/cyberSecurityData';
import { isEmail } from 'validator';

const regex = /^[ A-Za-z0-9_.&?!’:',-\/()\n]*$/;
const regexEmail = /^[ A-Za-z0-9_.@&?!',-\/()]*$/;

const FeedbackContent = () => {
  //redux store state
  const darkMode = useSelector(state => state.darkMode);
  const currentUser = useSelector(state => state.currentUser);
  const accessToken = useSelector(state => state.accessToken);
  //comp local state
  const [confirm, setConfirm] = useState(false);
  const [selectedOption, setSelectedOption] = useState('General');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [responseError, setResponseError] = useState('');

  //efect to initialize form values of there is a logged in user
  useEffect(() => {
    if (currentUser._id) {
      setName(currentUser.firstName + ' ' + currentUser.lastName);
      setEmail(currentUser.email);
    }
  }, [currentUser]);

  const renderLogo = () => {
    if (darkMode === true) return <img src={require('../../../../../images/TruKno-Logo-New.svg').default} alt="logo" style={{ maxWidth: "60px" }} className="img-fluid" />;
    if (darkMode === false) return <img src={require('../../../../../images/TruKno-Logo-New.svg').default} alt="logo" style={{ maxWidth: "60px" }} className="img-fluid" />;
  };

  const onSubmitClick = async () => {
    const newErrors = {};
    if (!selectedOption) newErrors.feedbackCategory = 'Please, choose category';
    if (!feedbackMessage) newErrors.message = 'Please, enter your message';
    if (feedbackMessage.length > 1000) newErrors.message = 'message must not exceed 1000 characters';
    if (name.length > 100) newErrors.message = 'name must not exceed 100 characters';
    if (!name) newErrors.name = 'Please, enter your name';
    if (!email || !isEmail(email)) newErrors.email = 'Please, enter a valid email';

    const validatedMessage = feedbackMessage.match(regex);
    const validatedName = name.match(regex);
    const validatedEmail = email.match(regexEmail);

    if (!validatedMessage) newErrors.message = 'Please, remove any special characters';
    if (!validatedName) newErrors.name = 'Please, remove any special characters';
    if (!validatedEmail) newErrors.email = 'Please, enter a valid email';

    if (Object.keys(newErrors).length > 0) return setErrors(newErrors);
    else setErrors({});

    const messageData = {
      feedbackCategory: selectedOption,
      firstName: name,
      email: email,
      message: feedbackMessage
    };

    const response = await CyberSecurity.post('/specificfeedback', messageData, {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    });

    if (response.data.error) return setResponseError(response.data.error);

    setConfirm(true);
  };

  const renderConfirm = () => {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center p-3">
        {renderLogo()}
        <h3 className="mt-3">Thank you for your feedback,</h3>
        <p>TruKno team will soon get back to you.</p>

        {/* <div className="text-center">
          <a href="https://app.slack.com/client/T01DCNBMTGB/C01D9DN81NZ" rel="noreferrer" target="_blank"><Button className="mt-3" onClick={() => document.body.click()}> Join</Button></a>
        </div> */}
      </div>
    );
  };

  const renderForm = () => {
    return (
      <div className="text-center pt-3">
        <h3>Tell us {currentUser.firstName}, How are we doing?</h3>
        <p className="pb-2">Your feedback keeps us moving in the right direction</p>

        {errors.feedbackCategory && <div className="error text-left mb-0" style={{ color: '#EA5454' }}>{errors.feedbackCategory}</div>}
        <Select options={feedbackOptions().map(value => { return { value, label: value }; })} className='react-select-container flex-grow-1 mb-2' classNamePrefix="react-select" placeholder="Choose Feedback Category" defaultValue={{ value: 'General', label: 'General' }} onChange={(option) => setSelectedOption(option.value)} />

        {errors.name && <div className="error text-left mb-0" style={{ color: '#EA5454' }}>{errors.name}</div>}
        <Form.Control className="mb-2" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} disabled={currentUser._id ? true : false} />

        {errors.email && <div className="error text-left mb-0" style={{ color: '#EA5454' }}>{errors.email}</div>}
        <Form.Control className="mb-2" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={currentUser._id ? true : false} />

        {errors.message && <div className="error text-left mb-0" style={{ color: '#EA5454' }}>{errors.message}</div>}
        <Form.Control className="mb-2" as="textarea" type="textarea" placeholder="Enter feedback here" style={{ height: 100 }} value={feedbackMessage} onChange={(e) => setFeedbackMessage(e.target.value)} />
        <div className="text-center my-3">
          <Button className="mt-2" onClick={onSubmitClick}>Submit</Button>
          {responseError && <div className="error text-left mb-0" style={{ color: '#EA5454' }}>{responseError}</div>}
        </div>
      </div>
    );
  };

  return (
    <div>
      {confirm ? renderConfirm() : renderForm()}
    </div>
  );
};

export default FeedbackContent;
